import { TCompanyLicenseRow } from "./types";
export {
  expirySortValue,
  formatDateYMD as formatDate,
} from "../../shared/utils/date";

export const seatsSort = (
  a: { original: TCompanyLicenseRow },
  b: { original: TCompanyLicenseRow },
): number => {
  // Primary Sort: Used Seats
  const usedDiff = a.original.seats.used - b.original.seats.used;
  if (usedDiff !== 0) {
    return usedDiff;
  }

  // Secondary Sort: Total Seats
  const totalA = a.original.seats.total ?? Number.POSITIVE_INFINITY;
  const totalB = b.original.seats.total ?? Number.POSITIVE_INFINITY;

  return totalA - totalB;
};
